import axios from "axios";
import router from "../router";
import { getCookies, removeCookies } from "@/util/auth";

const service = axios.create({
  baseURL: process.env.VUE_APP_API_PREFIX,
  timeout: 50000,
});

service.interceptors.request.use((config) => {
  config.headers["Authorization"] = "Bearer " + getCookies("Access-Token");
  return config;
});

service.interceptors.response.use(
  function(response) {
    
    return response.data;
  },
  function(error) {
    console.log(error.response);
    if (error.response.data.message === "Unauthenticated.") {
      removeCookies("Access-Token");
      removeCookies("Token-Type");
      router.push({
        name: "home",
      });
    }
    return Promise.reject(error);
  }
);

export default service;
